<template>
    <div>
        <div class="kqf-card  mg10 search-box mt20">
            <el-form :inline="true" :model="search" size="mini" class="demo-form-inline">
                     <el-form-item label="名称：">
                        <el-input v-model="search.menu_name" placeholder="名称"></el-input>
                    </el-form-item>
                    <el-form-item label="分类：" class="ml20">
                        <el-select v-model="search.category_id" @input="getList(1)">
                            <!-- <el-option label="全部" :value="-1"></el-option>
                            <el-option label="锁定" :value="1"></el-option>
                            <el-option label="未锁定" :value="0"></el-option> -->
                            <el-option v-for="(item,index) in datas.cate" :key="index" :label="item.category_title" :value="item.category_id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态：" class="ml20">
                        <el-radio-group v-model="search.is_online" @input="getList(1)">
                            <el-radio :label="-1">全部</el-radio>
                            <el-radio :label="0">关闭</el-radio>
                            <el-radio :label="1">开启</el-radio>
                        </el-radio-group>
                    </el-form-item>
                <el-form-item class="ml20">
                        <el-button type="primary" @click="getList(1)">查询</el-button>
                        <el-button @click="refresh">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="kqf-card mg10 pd10 mt20" v-loading="loading" style="min-width: 1100px">
            <el-table border :data="datas.list"   height="calc(100vh - 280px)">
                <el-table-column label="ID" width="80" prop="menu_id"></el-table-column>
                <el-table-column label="分类名称" width="130" prop="category_title"></el-table-column>
                <el-table-column label="接口名称" prop="menu_name"></el-table-column>
                <el-table-column label="对外名称" prop="foreign_name"></el-table-column>
                <el-table-column label="免费次数" width="120" prop="free_num"></el-table-column>
                <el-table-column label="成本价" width="120" prop="cost_price"></el-table-column>
                <el-table-column label="价格" width="120" prop="price"></el-table-column>
                <el-table-column label="分类ID" width="120" prop="category_id"></el-table-column>

                <el-table-column label="状态" width="100">
                    <template slot-scope="scope">
                        <el-switch @input="handlerStatus(scope.row)" :active-value="1" :inactive-value="0"
                                   :value="scope.row.is_online"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="editinfo(scope.row)" icon="el-icon-edit" type="primary" style="margin-right:10px">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <div class="flex center mt10">

                <div>
                    <el-pagination
                            @current-change="getList"
                            background
                            :page-size="datas.limit"
                            layout="total, prev, pager, next"
                            :total="datas.count">
                    </el-pagination>
                </div>
            </div> -->
        </div>

        <!--编辑-->
        <el-dialog
                title="编辑"
                :visible.sync="editdialog"
                width="600px"
        >
            <el-form label-width="130px" size="small" v-loading="editloading" >
                <el-form-item label="接口名称：">{{ editdata.menu_name }}</el-form-item>
                <el-form-item label="对外名称：" required>
                    <el-input v-model="editdata.foreign_name" style="width: 220px"/>
                </el-form-item>
                <el-form-item label="ID：" required>
                    <el-input v-model="editdata.menu_id" style="width: 220px"/>
                </el-form-item>
                <el-form-item label="免费次数：" required>
                    <el-input v-model="editdata.free_num" style="width: 220px"/>
                </el-form-item>
                <el-form-item label="成本价：" required>
                    <el-input v-model="editdata.cost_price" style="width: 220px"/>
                </el-form-item>
                <el-form-item label="价格：" required>
                    <el-input v-model="editdata.price" style="width: 220px"/>
                </el-form-item>
                <el-form-item label="排序：" required>
                    <el-input v-model="editdata.sort" style="width: 220px"/>
                </el-form-item>
                <el-form-item label="状态：" required>
                    <el-switch v-model="editdata.is_online" :active-value="1" :inactive-value="0"></el-switch>
                </el-form-item>
                <!-- <el-form-item label="ID" required>
                    <el-input v-model="editdata.menu_id" style="width: 220px"/>
                </el-form-item> -->
                <el-form-item>
                    <el-button type="primary" @click="edit()">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
    import {getQueryList,is_online,queryEdit} from "../../request/api/queryList/queryList";

    export default {

        data(){
            return{
                datas: [],
                search: this.getSearch(),
                //编辑信息
                editloading:false,
                editdialog:false,
                editdata:{
                    foreign_name: '',
                    menu_id:'',
                    free_num:'',
                    cost_price:'',
                    price:'',
                    is_online:0,
                    sort:'',
                },
                loading: false,
            }
        },
        created() {
            this.getList();
        },
        methods:{
            getSearch() {
                return {
                    menu_name:'',
                    is_online:-1,
                    category_id:'',
                    page: 1,
                }
            },
            getList(page) {
                this.search.page = page;
                this.loading = true;
                getQueryList({
                    page: page,
                    menu_name:this.search.menu_name,
                    is_online:this.search.is_online,
                    category_id:this.search.category_id,
                }).then(res => {
                    this.datas = res;
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
            },
            refresh() {
                this.search = this.getSearch();
                this.getList(1);
            },
            // 复制
            copySuccess() {
                this.$message.success("复制成功");
            },
            handlerStatus(row) {
                 this.loading = true;
                is_online({menu_id: row.menu_id}).then(() => {
                    row.is_online ^= 1;
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                })
            },
            //编辑信息填入
            editinfo(row){
                this.editdialog = true;
                this.editdata = Object.assign(this.editdata,row);
            },
            //编辑保存
            edit(){
                this.editloading = true;
                queryEdit({
                    ...this.editdata,
                }).then(() => {
                    this.editdialog = false;
                    this.$message.success("操作成功");
                    this.editloading = false
                    this.getList(1);
                    this.editloading = false;
                    this.editdata = {
                         menu_id:'',
                        free_num:'',
                        cost_price:'',
                        price:'',
                        is_online:0,
                        sort:'',
                        foreign_name: ''
                    }
                }).catch(() => {
                    this.editloading = false;
                })
            },
        },
    }
</script>